import React from 'react';
import { InstagramEmbed } from 'react-social-media-embed';
import './App.css';
import 'semantic-ui-css/semantic.min.css'
import { PAGE_TITLE_BASE } from './constants.js';
import { HomeCalendar } from './HomeCalendar.js';

export function Home() {
  document.title = PAGE_TITLE_BASE;

  return (
    <div className="App">
      
      <header className="App-header">
        Jazz Vocalists UK - Guide to upcoming UK concerts and latest releases.
      </header>

      <div id="Concerts">
        <HomeCalendar/>
      </div>

      <div id="HomeBottom">
        <div id="Releases">
          <h1>Latest Releases</h1>
          <iframe data-testid="embed-iframe" style={{borderRadius: "12px"}} src="https://open.spotify.com/embed/playlist/35HMKE0uwVl8w0Ln4e3u9R?utm_source=generator" width="100%" height="352" frameBorder="0" allowFullScreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify"></iframe>
        </div>

        <div id="SocialMedia">
          <h1>Social Media</h1>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <InstagramEmbed url="https://www.instagram.com/jazz.vocalists.uk/" width={328} />
          </div>
        </div>
      </div>
    </div>
  );
}         
